import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';
import { UpdateUserAccount } from '../../../features/account/models/UpdateUserAccount';
import { UserAccountAddress } from '../../../features/account/models/UserAccountAddress';

/**
 * Contract for updating account information.
 * Properties are flattened at the root level to match the API expectations.
 */
@ApiContract({ endpoint: Api.updateAccount, httpMethod: HttpMethods.put })
export class ApiUpdateAccount {
  firstName: string;
  lastName: string;
  organization: string;
  email: string;
  address: UserAccountAddress;
  phoneCountryCode: number;
  phoneNumber: string;
  faxCountryCode: number;
  fax: string;

  constructor(account: UpdateUserAccount) {
    // Flatten the account properties to the root level
    this.firstName = account.firstName;
    this.lastName = account.lastName;
    this.organization = account.organization;
    this.email = account.email;
    this.address = account.address;
    this.phoneCountryCode = account.phoneCountryCode;
    this.phoneNumber = account.phoneNumber;
    this.faxCountryCode = account.faxCountryCode;
    this.fax = account.fax;
  }
}
